import React from 'react';

const MenuFooter = () => {
        return (
                <div className="menu-footer">
                        <img src="dcc-logo.png" alt="dcc-logo" className="dcc-logo" />
                        <div className="credits">Built in 2024-25 by students <br /> at Durham University</div>
                </div>
        );
};

export default MenuFooter;